import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Route, useHistory } from 'react-router-dom';
import i18n from '../../../../i18n';

import { makeStyles } from '@material-ui/core/styles';
import { Hidden } from '@material-ui/core';

import { useActivate } from 'core/store/store';

import { isCatalogEmptySelector } from 'state/catalog/selectors';
import { CatalogActionType } from 'state/catalog/actions';

import { Text, TextTypography } from 'components/Text/Text';

import { RoutePath } from 'RoutePath';

import { CatalogAddDialog } from 'pages/Registration/components/CatalogAddDialog';
import { CatalogEmpty } from 'pages/Registration/components/CatalogEmpty';
import { CatalogList } from 'pages/Registration/components/CatalogList';
import { CatalogEditDialog } from 'pages/Registration/components/CatalogEditDialog';

const useStyles = makeStyles(theme => ({
    header: {
        padding: theme.spacing(2),
        paddingBottom: 25,
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: '#fafafa',
    },
}));

export const VendorCatalog = () => {
    useActivate(CatalogActionType.ACTIVATE, CatalogActionType.DEACTIVATE);
    const history = useHistory();
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    const isCatalogEmpty = useSelector(isCatalogEmptySelector);
    return (
        <Fragment>
            <Hidden smUp>
                <header className={classes.header}>
                    <Text typography={TextTypography.DISPLAY_STRONG}>{t('onboarding:wizard:catalog')}</Text>
                </header>
            </Hidden>
            {isCatalogEmpty ? <CatalogEmpty /> : <CatalogList />}
            <Route path={RoutePath.VENDOR_CATALOG_EDIT}>
                <CatalogEditDialog isVendor onClose={() => history.push(RoutePath.VENDOR_CATALOG)} />
            </Route>
            <Route path={RoutePath.VENDOR_CATALOG_ADD}>
                <CatalogAddDialog isVendor onClose={() => history.push(RoutePath.VENDOR_CATALOG)} />
            </Route>
        </Fragment>
    );
};
